import { MultiSelect, Text } from '@mantine/core';
import type { IntakeAnswers } from '../types';
import type { IntakeAction } from '../types';
import { PROVIDER_SPECIALTIES } from '@unify/fhir-model/provider-profile-datasets';

const TOPIC_OPTIONS = PROVIDER_SPECIALTIES.map((s) => ({ value: s.code, label: s.display }));

interface StepTopicsProps {
  answers: IntakeAnswers;
  dispatch: React.Dispatch<IntakeAction>;
}

export function StepTopics({ answers, dispatch }: StepTopicsProps): JSX.Element {
  return (
    <>
      <Text size="sm" c="dimmed" mb="sm">
        We recommend choosing up to three areas you&apos;d like to focus on first.
      </Text>
      <MultiSelect
        placeholder="Search or select..."
        data={TOPIC_OPTIONS}
        value={answers.topics}
        onChange={(value) => dispatch({ type: 'SET_TOPICS', payload: value })}
        searchable
        clearable
        maxValues={5}
      />
    </>
  );
}
